import Vue from 'vue';
import moment from 'moment';
import logger from '@/utils/logger';
import redirect from '@/router/redirect';

window.onerror = () => {
  return true;
};

Vue.config.errorHandler = (error, vm, info) => {
  let payload = {
    url: document.location.href,
    browserTime: moment().format('DD-MM-YYYY HH:mm:ss.sss'),
    extra: vm.$store._modules.root._children,
    error: JSON.stringify(error, Object.getOwnPropertyNames(error)),
    info: info
  };
  // Informamos del error
  logger.reportarError(payload);

  // Redirigimos a la pantalla de error
  redirect.toError(vm.$t('message.errores.generico'));
};
